module.exports = __webpack_public_path__ + "static/media/INFJ.84197eeb.png";